
<script setup>
import { ref, onMounted, computed } from 'vue'
import axios from 'axios'

const stats = ref(null)
const loading = ref(true)
const error = ref(null)

const hasData = computed(() => stats.value && stats.value.details?.length > 0)

onMounted(async () => {
  try {
    const response = await axios.get('/returned_clients_statistics/')
    if (response.data.status === 'success') {
      if (response.data.statistics) {
        stats.value = response.data.statistics
      } else {
        stats.value = null
      }
    } else {
      error.value = 'Сервер вернул ошибку: ' + response.data.message
    }
  } catch (err) {
    error.value = err.message
  } finally {
    loading.value = false
  }
})
</script>

<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        Статистика возвращённых клиентов
      </div>
      <div class="card-body">
        <div v-if="loading" class="text-center">Загрузка...</div>
        <div v-else-if="error" class="text-danger">Ошибка: {{ error }}</div>
        <div v-else-if="!hasData">
          <p class="text-muted">Нет данных о повторных подключениях.</p>
        </div>
        <div v-else>
          <p><strong>Всего клиентов:</strong> {{ stats.total }}</p>
          <ul class="list-group mb-3">
            <li class="list-group-item d-flex justify-content-between align-items-center">
              Интернет <span class="badge bg-primary">{{ stats.by_service.internet }}</span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
              Телефон <span class="badge bg-primary">{{ stats.by_service.phone }}</span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
              Домофон <span class="badge bg-primary">{{ stats.by_service.intercom }}</span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
              Видеонаблюдение <span class="badge bg-primary">{{ stats.by_service.video_sur }}</span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
              Телевидение <span class="badge bg-primary">{{ stats.by_service.tv }}</span>
            </li>
          </ul>

<!--          <h5>Детали:</h5>-->
<!--          <ul class="list-group">-->
<!--            <li v-for="(item, index) in stats.details" :key="index" class="list-group-item">-->
<!--              <p><strong>ID адреса:</strong> {{ item.address_id }}</p>-->
<!--              <p><strong>Дата повторного подключения:</strong> {{ item.reconnection_date }}</p>-->
<!--              <p><strong>Дата предыдущего действия:</strong> {{ item.previous_action_date }}</p>-->
<!--              <p><strong>Подключённые услуги:</strong> {{ item.services_reconnected.join(', ') }}</p>-->
<!--            </li>-->
<!--          </ul>-->
        </div>
      </div>
    </div>
  </div>
</template>
